<div class="chart-wrapper">
    <ngx-charts-bar-horizontal [view]="view" [results]="multi" [gradient]="gradient" [xAxis]="showXAxis"
        [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" (select)="onSelect($event)">
    </ngx-charts-bar-horizontal>
</div>